import { render, staticRenderFns } from "./YearComparison.vue?vue&type=template&id=19636990&"
import script from "./YearComparison.vue?vue&type=script&lang=js&"
export * from "./YearComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports